<template>
    <div style="height:100%;"> 
        <title>快递服务配置</title>
        <div class="mainPart">
            <!--S 公用头部切换-->
           <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
            <!--E 公用头部切换-->
            <!-- S头部搜索区域 -->
            <el-form :inline="true" :model="searchClsForm" class="searchForm">
                <el-form-item label="关键词">
                    <el-input v-model="searchClsForm.keywords" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="状态" class="formTimeSlot">
                    <el-select v-model="searchClsForm.status" placeholder="请选择" clearable>
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getSysexpparainfoList('query')">查询</el-button>
                </el-form-item>
            </el-form>
            <!-- E头部搜索区域 -->
            <!-- S 分类列表 -->
            <el-table class="comTable lev1Table" ref="lev1Table"
            :data="sysexpparainfoList" border :max-height="tableHeight" v-loading="vloading">
                <el-table-column label="序号" type="index" width="150"></el-table-column>
                <el-table-column label="快递名称">
                    <template slot-scope="scope">{{ scope.row.name}}</template>
                </el-table-column>   
                <el-table-column label="状态" prop="status" sortable>
                    <template slot-scope="scope">
                        <el-switch v-if="scope.row.id" :width="45" class="isSwitch" :value="scope.row.status ? true :false" @change="updateStatus(scope.row,scope.row.status)" :active-text="scope.row.status?'启':'禁'"></el-switch>
                    </template>
                </el-table-column>       
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <div class="handle">
                            <span class="detailA" @click="getShowDlog(scope.row,'detail')" title="详情"><i class="icondetails" v-if="scope.row.id"></i></span>
                            <span @click="getShowDlog(scope.row,'edit')" title="配置"><i class="iconedit"></i></span>
                        </div>
                    </template>
                </el-table-column>
                <template slot="empty" v-if="vloading">
                    <div :class="{noData:vloading}"></div>
                </template>
                <template slot="empty" v-else>
                  <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!-- E 分类列表 -->
            <!-- S 分页 -->
            <!-- <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" :pageSize="pageSize"></Page> -->
            <!-- E 分页 -->
        </div>
        <!-- 网店管家弹框 -->
        <WdgjOperate :wdgjDlog="wdgjDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></WdgjOperate>
        <!-- E店宝弹框 -->
        <EdbOperate :EdbDlog="EdbDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></EdbOperate>
        <!-- 旺店通ERP弹框 -->
        <WdtOperate :WdtDlog="WdtDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></WdtOperate>
        <!-- 承诺达弹框 -->
        <CndOperate :CndDlog="CndDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></CndOperate>
        <!-- 管易ERP弹框 -->
        <GyerpOperate :GyerpDlog="GyerpDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></GyerpOperate>
        <!-- 菜鸟热敏弹框 -->
        <CnrmOperate :CnrmDlog="CnrmDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></CnrmOperate>
        <!-- 跨越速运弹框 -->
        <KysyOperate :KysyDlog="KysyDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></KysyOperate>
        <!-- 安能物流弹框 -->
        <AnwlOperate :AnwlDlog="AnwlDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></AnwlOperate>
        <!-- 京东弹框 -->
        <JdOperate :JdDlog="JdDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></JdOperate>
        <!-- 韵达快运弹框 -->
        <YdkyOperate :YdkyDlog="YdkyDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></YdkyOperate>
        <!-- 韵达快运弹框 -->
        <LbkdOperate :LbkdDlog="LbkdDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></LbkdOperate>
        <!-- 圆通速递弹框 -->
        <YtsdOperate :YtsdDlog="YtsdDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></YtsdOperate>
        <!-- 顺丰弹框 -->
        <SfOperate :SfDlog="SfDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></SfOperate>
        <!-- 京东云仓弹框 -->
        <JdycOperate :JdycDlog="JdycDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></JdycOperate>
        <!-- 金蝶弹框 -->
        <JdieOperate :JdieDlog="JdieDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></JdieOperate>
        <!-- 新京东弹框 -->
        <JdOperateNew :JdDlogNew="JdDlogNew" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></JdOperateNew>
        <!--菜鸟速递-->
        <CnsdOperate :CnsdDlog="CnsdDlog" :operate="operate" :id="id" :expmodecode="expmodecode" @closeChild="getCloseDlog"></CnsdOperate>
    </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
    name:'DlyConfiguration',
    //  *********************************************************************组件
    components: {
        CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
        Page: resolve => require(["@/components/common/Page.vue"],resolve),
        WdgjOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/WdgjOperate.vue"],resolve),//网店管家弹窗
        EdbOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/EdbOperate.vue"],resolve),//E店宝弹窗
        WdtOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/WdtOperate.vue"],resolve),//旺店通ERP弹窗
        CndOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/CndOperate.vue"],resolve),//承诺达弹窗
        GyerpOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/GyerpOperate.vue"],resolve),//管易ERP弹窗
        CnrmOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/CnrmOperate.vue"],resolve),//菜鸟热敏弹窗
        KysyOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/KysyOperate.vue"],resolve),//跨越速运弹窗
        AnwlOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/AnwlOperate.vue"],resolve),//安能物流弹窗
        JdOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/JdOperate.vue"],resolve),//京东弹窗
        YdkyOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/YdkyOperate.vue"],resolve),//韵达快运弹窗
        LbkdOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/LbkdOperate.vue"],resolve),//联邦快递弹窗
        YtsdOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/YtsdOperate.vue"],resolve),//圆通速递弹窗
        SfOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/SfOperate.vue"],resolve),//顺丰弹窗
        JdycOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/JdycOperate.vue"],resolve),//京东云仓弹窗
        JdieOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/JdieOperate.vue"],resolve),//金蝶弹窗
        JdOperateNew: resolve => require(["@/components/ManageFolder/DeliveryConfig/JdOperateNew.vue"],resolve),// 新京东弹窗
        CnsdOperate: resolve => require(["@/components/ManageFolder/DeliveryConfig/CnsdOperate.vue"],resolve),// 菜鸟速递弹窗
    },
    //   *********************************************************************变量
    data() {
        return {
            vloading:false,//加载中
            currentTit:3, //当前选中菜单
            searchClsForm: {
                keywords: '',
                status:'', //状态
            },    
            pageSize: 100, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息     
            tableHeight: window.innerHeight*.8, //表格动态高度
            sysexpparainfoList: [],//列表信息  
            wdgjDlog:false,//网店管家弹窗
            EdbDlog:false,//E店宝弹窗
            WdtDlog:false,//旺店通ERP弹窗
            CndDlog:false,//承诺达弹窗
            GyerpDlog:false,//管易ERP弹窗
            CnrmDlog:false,//菜鸟热敏弹窗
            KysyDlog:false,//跨越速运弹窗
            AnwlDlog:false,//安能物流弹窗
            JdDlog:false,//京东弹窗
            YdkyDlog:false,//韵达快运
            LbkdDlog:false,//联邦快递
            YtsdDlog:false,//圆通速递
            SfDlog:false,//顺丰
            JdycDlog:false,//京东云仓
            JdieDlog:false,//金蝶
            JdDlogNew: false, // 新京东弹窗
            CnsdDlog: false, // 菜鸟速递弹窗
            id:'',//快递id
            operate:'',//弹窗操作
            type:'',//快递类型
            expmodecode:'',//快递code
            flowcode:'',//流向编号
        }
    },

    //   *********************************************************************方法
    methods: { 
        // 获取快递列表
        getSysexpparainfoList(query){
            this.vloading = true;
            this.flowcode = JSON.parse(localStorage.getItem('userInfoMd')).flowcode;
            let params = {
                keywords: this.searchClsForm.keywords,
                ownerucode:this.flowcode,//所属编号，总部存0，其余为对应网点的编号
                status: this.searchClsForm.status,
                pageparam: {
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                    // isnewcomp: 1 //是否需要重新统计页数
                }
            }
            api.GET_SYSEXPPARAINFOLIST(params).then((res) => {
                if(res.data.status == "200"){
                    sessionStorage.setItem('printWayListInfo','');
                    sessionStorage.setItem('printWayListValue','');
                    this.vloading = false;
                    this.pagebBean.totalnum = 13;
                    let sysexpparainfoList = res.data.data;
                    let sysexpname=['承诺达','菜鸟热敏','跨越速运','安能物流','韵达快运','联邦快递（国内）','圆通速递','顺丰','菜鸟速递']; // '京东云仓','金蝶'
                    if(this.ElementControls('JDseriesExpress')==1) {
                        sysexpname = sysexpname.concat(['京东快递'])
                    }
                    if(this.ElementControls('JDseriesExpress')==2) {
                        sysexpname = sysexpname.concat(['京东'])
                    }
                    this.sysexpparainfoList = [];
                    if(sysexpparainfoList.length > 0){
                        sysexpparainfoList.map((sitem,sindex) => {
                            if(sysexpname.includes(sitem.name)){
                                if(sitem.id==null||sitem.id==''){
                                    sitem.expmodecode = sitem.code;
                                }
                                if(!this.sysexpparainfoList.includes(sitem)){
                                    this.sysexpparainfoList.push(sitem);
                                }
                            }
                        })
                    }else{
                        this.sysexpparainfoList = [];
                    }
                    // if(res.data.pagebean){
                    //     this.pagebBean = res.data.pagebean
                    // }
                }else{
                    this.vloading = false;
                    this.$message.error(res.data.message);
                }
            })
        },
        // 更改状态
        updateStatus(row,val){
            let valTxt = '';
            let status = 0;
            if(!val){
                valTxt = '启用';
                status = 1;
            }else{
                valTxt = '禁用';
                status = 0;
            }
            this.$confirm(`确定要${valTxt}该快递吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    id:row.id,
                    status:status
                }
                api.UPDATESTATUS(params).then((res) => {
                    if(res.data.status == '200'){
                        this.$message.success(`${valTxt}成功`);
                        this.getSysexpparainfoList('query')
                        sessionStorage.setItem('printWayListInfo','');
                        sessionStorage.setItem('printWayListValue','');
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {});
        },
        // 接收分页信息
        // updatePage(size,num) {
        //     this.pageSize = size;
        //     this.currentPage = num;
        //     this.getSysexpparainfoList();
        // },
        // 打开快递弹框
        getShowDlog(row,operate){
            this.id = row.id;
            this.expmodecode = row.expmodecode;
            this.operate = operate;
            this.type = row.name;
            if(row.name == '网店管家'){
                this.wdgjDlog = true;
            }else if(row.name == 'E店宝'){
                this.EdbDlog = true
            }else if(row.name == '旺店通ERP'){
                this.WdtDlog = true
            }else if(row.name == '承诺达'){
                this.CndDlog = true
            }else if(row.name.includes('管易')){
                this.GyerpDlog = true
            }else if(row.name == '菜鸟热敏'){
                this.CnrmDlog = true
            }else if(row.name == '跨越速运'){
                this.KysyDlog = true
            }else if(row.name == '安能物流'){
                this.AnwlDlog = true
            }else if(row.name == '京东快递'){
                this.JdDlog = true
            }else if(row.name == '韵达快运'){
                this.YdkyDlog = true
            }else if(row.name == '联邦快递（国内）' || row.name == '联邦快递'){
                this.LbkdDlog = true
            }else if(row.name == '圆通速递'){
                this.YtsdDlog = true
            }else if(row.name == '顺丰'){
                this.SfDlog = true
            }else if(row.name == '京东云仓'){
                this.JdycDlog = true
            }else if(row.name == '金蝶'){
                this.JdieDlog = true
            }else if(row.name == '京东'){
                this.JdDlogNew = true
            }else if(row.name == '菜鸟速递'){
                this.CnsdDlog = true
            }
        },
        // 关闭快递弹框
        getCloseDlog(done){
            let type = this.type;
            if(type == '网店管家'){
                this.wdgjDlog = false
            }else if(type == 'E店宝'){
                this.EdbDlog = false
            }else if(type == '旺店通ERP'){
                this.WdtDlog = false
            }else if(type == '承诺达'){
                this.CndDlog = false
            }else if(type.includes('管易')){
                this.GyerpDlog = false
            }else if(type == '菜鸟热敏'){
                this.CnrmDlog = false
            }else if(type == '跨越速运'){
                this.KysyDlog = false
            }else if(type == '安能物流'){
                this.AnwlDlog = false
            }else if(type == '京东快递'){
                this.JdDlog = false
            }else if(type == '韵达快运'){
                this.YdkyDlog = false
            }else if(type == '联邦快递' || type == '联邦快递（国内）'){
                this.LbkdDlog = false
            }else if(type == '圆通速递'){
                this.YtsdDlog = false
            }else if(type == '顺丰'){
                this.SfDlog = false
            }else if(type == '京东云仓'){
                this.JdycDlog = false;
            }else if(type == '金蝶'){
                this.JdieDlog = false;
            }else if(type == '京东'){
                this.JdDlogNew = false
            }else if(type == '菜鸟速递'){
                this.CnsdDlog = false
            }
            if(done == 1){
                this.getSysexpparainfoList('query');//刷新列表信息
            }
        },
        //删除提示框
        delDlog() {
            this.$confirm('确定删除该商品分类吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            }).catch(() => {
                    
            });
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.lev1Table.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 120; 
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    //   *********************************************************************初始化
    mounted(){
        //在dom渲染之后
        // //取节点,,暂不用
        // setTimeout(()=>{
        // document.querySelectorAll(".cell")[3].title= "点击排序";
        // },1000)
        setTimeout(()=>{
            this.getHeight();
        },200);
        this.getSysexpparainfoList();// 获取列表信息
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }

}
</script>
<style scoped>
@import '../../Css/style.css';
.warning {display: inline-block;line-height: 22px;color:#f56c6c;margin-top: 8px}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/SysConfiguration/OrdConfiguration/DlyConfiguration.vue